import React from 'react';
import { useMedia } from 'react-use';
import { Link } from 'react-router-dom';

import { CA } from 'contexts';

import cxiInviteImage from 'assets/images/not_paid_cxi.png';
import cxiPaidImage from 'assets/images/c2a-cxi-paid.jpg';
import cxiPaidMobileImage from 'assets/images/c2a-cxi-paid-mobile.jpg';

import * as Styled from './StyledCxi';

export function Cxi() {
    const { state } = React.useContext(CA);
    const { cxi } = state;
    const isMobile = useMedia('(max-width: 991px)');

    const hasCxi = cxi !== false;

    let src = cxiInviteImage;
    let url = 'https://www.openstartups.net/site/produtos/100-10-1.html';
    if (hasCxi) {
        src = isMobile ? cxiPaidMobileImage : cxiPaidImage;
        url = '/100-10-1';
    }

    if (!hasCxi || hasCxi === null) {
        return null;
    }

    // return hasCxi ? (
    //     <Styled.Cxi as={Link} to={url}>
    //         <img src={src} alt="Banner Paid 100-10-1" />
    //     </Styled.Cxi>
    // ) : (
    //     <Styled.Cxi as="a" href={url} rel="noref">
    //         <img width="100%" src={src} alt="Banner Invite 100-10-1" />
    //     </Styled.Cxi>
    // );

    return !hasCxi ? null : (
        <Styled.Cxi as={Link} to={url}>
            <img src={src} alt="Banner Paid 100-10-1" />
        </Styled.Cxi>
    );
}

export default Cxi;
